
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    list: {
      type: Array,
      default: []
    },
    fatherKey: {
      type: String,
      default: ""
    }
  }
})
export default class Cell extends Vue {
  handleRouterLink(item, collection_key) {
    if (item.level === "1") {
      // @ts-ignore
      this.$router.push({ path: '/info-collection-list', query: { collection_key,lable:item.label}})
    } else {
      if(item.collect_status === "1") {
        // @ts-ignore
        this.$router.push({ path: '/info-collection-detail', query: { fatherKey: (this as any).fatherKey, collection_key,lable:item.label }})
      }
    }
  }
}
